import styled from "styled-components";
import { TimeSlotButtonStyles } from "../../types/styles";
import Icon from "../Icon/Icon";
import { TickSolid } from "../../assets/icons";
import { useTranslation } from "react-i18next";

const StyledButton = styled.button<{
  isSelected: boolean;
  styles: TimeSlotButtonStyles;
}>`
  background-color: ${({ isSelected, styles }) =>
    isSelected ? styles.OverallBookButtonColour : "#ffffff"};
  color: ${({ isSelected, styles }) =>
    isSelected ? styles.OverallBookButtonFontColour : "#202227"};
  padding: 0px 12px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: 1px solid
    ${({ isSelected, styles }) =>
      isSelected ? styles.OverallBookButtonColour : "#202227"};
  border-radius: 4px;
  height: 44px;
  font-weight: 700;
  font-size: 1em;
  font-family: inherit;
  transition: border-color 0.25s;

  &:focus,
  &:focus-visible {
    outline: 4px auto -webkit-focus-ring-color;
  }
`;

const StyledIcon = styled(Icon)`
  font-size: 18px;
`;

export type TimeSlotButtonProps = {
  text: string;
  isSelected: boolean;
  onClick: (text: string) => void;
  styles: TimeSlotButtonStyles;
};

export const TimeSlotButton: React.FC<TimeSlotButtonProps> = ({
  text,
  isSelected,
  onClick,
  styles,
}) => {
  const { t } = useTranslation();
  return (
    <StyledButton
      styles={styles}
      isSelected={isSelected}
      onClick={() => onClick(text)}
      aria-label={
        isSelected
          ? t("DeselectTimeSlotAriaLabel", { time: text })
          : t("SelectTimeSlotAriaLabel", { time: text })
      }
      data-id={`time-slot-button-${text}`}
    >
      {isSelected && <StyledIcon icon={TickSolid} />}
      {text}
    </StyledButton>
  );
};

export default TimeSlotButton;
